// Host-side adapter — implements the TeamStorage interface against
// the standalone Jigyasa FastAPI backend (/api/team/*).
//
// Lives in /standalone/ rather than inside the package because the
// package must not import the host's axios client. A future
// Aumonline product writes its own adapter the same way, against
// its own backend.

import { api } from "./api";

const unwrap = async (req) => (await req).data;

export const createTeamStorage = () => ({
  // ---- members ----
  listMembers: (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.status) params.set("status", filters.status);
    if (filters.role) params.set("role", filters.role);
    if (filters.owned_module) params.set("owned_module", filters.owned_module);
    const qs = params.toString();
    return unwrap(api.get(`/team/members${qs ? `?${qs}` : ""}`));
  },
  createMember: (data) => unwrap(api.post("/team/members", data)),
  updateMember: (id, patch) => unwrap(api.patch(`/team/members/${id}`, patch)),
  removeMember: (id, reassignTo) =>
    unwrap(api.delete(`/team/members/${id}`, { data: { reassign_to: reassignTo || null } })),
  transferOwnership: (toId) => unwrap(api.post(`/team/members/${toId}/transfer-ownership`)),
  getOpenItemsCount: (memberId) => unwrap(api.get(`/team/members/${memberId}/open-items-count`)),

  // ---- module ownership ----
  setMemberModules: (memberId, modules) =>
    unwrap(api.post(`/team/members/${memberId}/modules`, { modules })),

  // ---- invites ----
  listInvites: () => unwrap(api.get("/team/invites")),
  createInvite: (data) => unwrap(api.post("/team/invites", data)),
  revokeInvite: (id) => unwrap(api.post(`/team/invites/${id}/revoke`)),

  // ---- teams ----
  listTeams: () => unwrap(api.get("/team/teams")),
  createTeam: (data) => unwrap(api.post("/team/teams", data)),
  updateTeam: (id, patch) => unwrap(api.patch(`/team/teams/${id}`, patch)),
  deleteTeam: (id) => unwrap(api.delete(`/team/teams/${id}`)),
  assignToTeam: (teamId, memberId, roleInTeam) =>
    unwrap(api.post(`/team/teams/${teamId}/assignments`, { member_id: memberId, role_in_team: roleInTeam })),
  unassignFromTeam: (teamId, memberId) =>
    unwrap(api.delete(`/team/teams/${teamId}/assignments/${memberId}`)),

  // ---- audit ----
  listAuditLog: (filters = {}) => {
    const limit = filters.limit ? `?limit=${filters.limit}` : "";
    return unwrap(api.get(`/team/audit-log${limit}`));
  },
});
